import { ReportPostUtils } from "../utils";
import { ReportListItem } from "./ListItem";

export const WhyReporting = () => {
  return (
    <>
      {ReportPostUtils.whyReportingListItems.map((item) => (
        <ReportListItem key={item} label={item} />
      ))}
    </>
  );
};
